import { useContext } from 'react'

import { AgGridContext } from '@src/context/use_ag_grid_context'

export function useAgGrid() {
    const context = useContext(AgGridContext)
    if (!context) throw new Error('useAgGrid must be used within AgGridContext.Provider')
    return context
}
